module.exports = __webpack_public_path__ + "soompi-default-avatar.a39e2679bab38016fdb146ad977aa008.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/soompi-default-avatar.png
// module id = 283
// module chunks = 9